export default [
    {
        path: '/warehouse/replenishment',
        name: 'replenishment',
        props: true,
        component: () => import('@/views/warehouse/replenishment/index.vue'),
        meta: {
            pageTitle: 'Replenishment',
            breadcrumb: [
                {
                text: 'Replenishment',
                active: true,
                },
            ],
        },
    },
    {
        path: '/warehouse/replenishment/add',
        name: 'create-replenishment',
        component: () => import('@/views/warehouse/replenishment/create.vue'),
        meta: {
            pageTitle: 'Create Replenishment',
            breadcrumb: [
                {
                text: 'Replenishment',
                to: { name: 'replenishment' },
                },
                {
                text: 'Create Replenishment',
                active: true,
                },
            ],
        },
    },
    {
        path: '/warehouse/replenishment/:id',
        name: 'detail-replenishment',
        props: true,
        component: () => import('@/views/warehouse/replenishment/detail.vue'),
        meta: {
            pageTitle: 'Detail Replenishment',
            breadcrumb: [
                {
                text: 'Replenishment',
                to: { name: 'replenishment' },
                },
                {
                text: 'Detail Replenishment',
                active: true,
                },
            ],
        },
    },
]